<script lang="ts" setup>
import { navigateTo } from '#imports';
import { getAiSettingsRoute } from '#layers/ai/utils/routes';
import { useWorkspaceStore } from '#layers/workspace/public';

const workspaceStore = useWorkspaceStore();

function configureConnector() {
	navigateTo(getAiSettingsRoute(workspaceStore.currentWorkspaceSlug ?? undefined));
}
</script>

<template>
	<DEmpty
		fill
		icon="lucide:sparkles"
		:title="$t('ai.chat.empty.title')"
		:description="$t('ai.chat.empty.description')"
		:action-button-label="$t('ai.chat.empty.action')"
		action-button-icon="lucide:settings"
		@action="configureConnector"
	/>
</template>
